import baseConfig from './baseConfig'
import setFields from './setFields'

import { getXiaomanBaseInfo } from '@/services/configXiaoman'
import { toType } from '@/lib/utils'

export default {
  namespaced: true,
  state: {
    allData: {},
    baseConfigData: {},
    fieldsData: {},
    loading: undefined
  },
  mutations: {
    GET_XIAOMAN_BASEINFO (state, data = {}) {
      state.allData = data
      let { isopen, account, syncusertime, xiaomanuserassoc = [], syncfieldtime, xiaomanfieldassoc = [] } = data
      if (toType(xiaomanuserassoc) !== 'array') {
        xiaomanuserassoc = []
      }
      if (toType(xiaomanfieldassoc) !== 'array') {
        xiaomanfieldassoc = []
      }
      state.baseConfigData = {
        isopen,
        account,
        syncusertime,
        xiaomanuserassoc
      }
      state.fieldsData = {
        isopen,
        syncfieldtime,
        xiaomanfieldassoc
      }
    },
    SET_LOADING (state, data) {
      state.loading = data
    },
    SET_XIAOMAN_OPEN (state, data) {
      state.allData.isopen = data
      state.baseConfigData.isopen = data
      state.fieldsData.isopen = data
    }
  },
  actions: {
    async fetchXiaomanBaseInfo ({ commit, rootState }, params = {}) {
      if (params.showLoading) {
        commit('SET_LOADING', true)
      }
      let chain = await getXiaomanBaseInfo()
      chain
        .config({ tip: false })
        .onSuccess(raw => {
          commit('GET_XIAOMAN_BASEINFO', raw)
        })
        .onNetSuccess(res => {
          commit('SET_LOADING', false)
        })
        .fetch()
      return chain
    }
  },
  modules: {
    baseConfig,
    setFields
  }
}
